module.exports = __webpack_public_path__ + "static/media/Tommen Baratheon 1.c34cd557.jpg";